<template>
  <v-row>
    <v-col
      v-for="measureAnalysis in localAnalysis"
      :key="measureAnalysis.id || measureAnalysis._id"
      xl="4"
      lg="4"
      md="6"
      sm="12"
      xs="12"
    >
      <MeasureCard
        v-if="measureAnalysis.active && !loading"
        :id="measureAnalysis.id || measureAnalysis._id"
        :populateWith="measureAnalysis"
        :site="site"
        :componentId="measureAnalysis.nodeRef"
        :isCompletedOrLocked="isCompletedOrLocked"
        :analysisMeasureHistory="measureAnalysis.history ? measureAnalysis.history.measures : []"
      >
        <template v-slot:title>
          {{ measureAnalysis.nodeName }} {{ measureAnalysis.nodeType }}
        </template>
      </MeasureCard>
    </v-col>
  </v-row>
</template>


<script>
import MeasureCard from '@/components/sites/MeasureCard.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        MeasureCard,
    },
    props: {
        analysisType: {
            type: Object,
            default: () => ({}),
        },
        analyses: {
            type: Object,
            default: () => [],
        },
        analysis: {
            type: Object,
            default: () => ({}),
        },
        site: {
            type: Object,
            default: () => ({}),
        },
        isCompletedOrLocked: {
            type: Boolean,
            default: false,
        },
        nodes: {
            type: [Object, Array],
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
            localAnalysis: [],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'siteLang',
        ]),
    },
    async created() {
        await this.matchAnalysis();
        await this.getMeasureHistory();
    },
    methods: {
        async getMeasureHistory() {
            this.loading = true;
            if (this.analysis?.analyses?.length > 0) {
                const [firstElement] = this.analysis.analyses;
                const analysisType = firstElement.analysisType.ref;
                // eslint-disable-next-line no-underscore-dangle
                const activity = firstElement.activity.id || firstElement.activity._id;
                const response = await this.$rq.getMeasureHistory({
                    analysisType,
                    activity,
                });
                const componentAnalysesMeasureHistories = response.data.results;
                componentAnalysesMeasureHistories.forEach(history => {
                    this.localAnalysis.forEach(analysis => {
                        if (analysis.nodeRef === history.source.component) {
                            Object.assign(analysis, { history });
                        }
                    });
                });
            }
            this.loading = false;
        },
        async matchAnalysis() {
            const analysesArray = Object.values(this.analyses);

            if (analysesArray.length > 0) {
                const acc = [];
                this.localAnalysis = analysesArray.forEach(analysis => {
                    const matchedAnalyses = analysis.analyses.filter(analysisItem => analysisItem.analysisType
                    && analysisItem.analysisType.ref === this.analysisType.ref);

                    const matchedItems = matchedAnalyses.flatMap(analysisItem => {
                        if (analysisItem.source && analysisItem.source.ref) {
                            const matchedNodes = this.findMatchingNodes(this.nodes, analysisItem.source.ref);
                            return matchedNodes.map(node => ({
                                ...analysisItem,
                                nodeName: node.name,
                                nodeActive: node.active,
                                nodeType: node.nodeType,
                                nodeRef: node.ref,
                                treeOrder: node.treeOrder,
                            }));
                        }
                        return [analysisItem];
                    });
                    return acc.unshift(...matchedItems);
                });
                // sort by treeOrder
                this.localAnalysis = acc.sort((a, b) => a.treeOrder - b.treeOrder);
            }
        },

        findMatchingNodes(nodes, ref) {
            const matchingNodes = [];

            const searchNodes = node => {
                if (node.nodeType === 'Component' && node.ref === ref) {
                    matchingNodes.push(node);
                }

                if (node.children && Array.isArray(node.children)) {
                    node.children.forEach(childNode => searchNodes(childNode));
                }
            };

            if (Array.isArray(nodes)) {
                nodes.forEach(node => searchNodes(node));
            } else {
                searchNodes(nodes);
            }
            return matchingNodes;
        },
    },
};

</script>
